import { Box, IconButton } from "@mui/material";

import { CheckCircleIcon, FolderOpenIcon } from "@/shared/foundation/icons/mui";

interface SuccessIconProps {
  isHovered: boolean;
}

export const SuccessIcon: React.FC<SuccessIconProps> = ({ isHovered }) => {
  return (
    <Box
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isHovered ? (
        <IconButton sx={{ padding: 0 }}>
          <FolderOpenIcon color="primary" />
        </IconButton>
      ) : (
        <CheckCircleIcon color="success" />
      )}
    </Box>
  );
};
